<template>
     <v-footer
      dark 
      height="auto"
    >
      <v-card
        class="flex"
        flat
        tile
               
      >
        <v-card-title class="teal justify-center">
          <strong class="subheading justify-xs-center">ვამზადებ ხელნაკეთ ნივთებს შეკვეთით</strong>
            
          <v-spacer></v-spacer>
          <iframe src="https://www.facebook.com/plugins/like.php?locale=ka_GE&href=https://www.facebook.com/Tsiklauris-Art-901014999933121/%2Fdocs%2Fplugins%2F&width=290&layout=button_count&action=like&size=large&show_faces=true&share=true&height=46&appId=350792305686802" width="290" height="46" style="border:none;overflow:hidden; hight: 24px; padding-top: 0.8em; margin: 0.8em" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>

          <v-btn
            v-for="icon in icons"
            :key="icon"
            class="mx-3"
            dark
            icon
            :href="icon.iconLink"
          >
            <v-icon size="24px">{{ icon.iconName }}</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-actions class="grey darken-3 justify-center text-xs-center">
          &copy;2019 — <a href="https://www.facebook.com/tsfunion/?ref=bookmarks"><strong>ა(ა)იპ წიკალაურთა საგვარეულო ერთობა</strong></a>
        </v-card-actions>
      </v-card>
    </v-footer>
</template>

<script>
export default {
    data: () => ({
        icons: [
          {
          iconName: 'fab fa-facebook',
          iconLink: 'https://www.facebook.com/Tsiklauris-Art-901014999933121/'
          }
        // 'fab fa-twitter',
      // 'fab fa-google-plus',
      // 'fab fa-linkedin',
      // 'fab fa-instagram'
        ]
    })
}
</script>

<style>
a {
  color: white;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue